import React from 'react';
import PropTypes from 'prop-types';

// A carousel in the app preview: the images side by side, swiped (or
// scrolled) one at a time, with a dot per image; inside the side margins,
// or edge to edge (`fullWidth`)
const CarouselPreview = ({ images, fullWidth }) => {
  if (!images?.length) {
    return null;
  }
  return (
    <div
      className={`app-preview-carousel${
        fullWidth ? ' app-preview-carousel--full' : ''
      }`}
    >
      <div className="app-preview-carousel__track">
        {images.map((slide, index) => (
          <div key={index} className="app-preview-carousel__slide">
            <img src={slide.image} alt="" />
            {slide.author ? <p>{slide.author}</p> : null}
          </div>
        ))}
      </div>
      {images.length > 1 && (
        <div className="app-preview-carousel__dots">
          {images.map((slide, index) => (
            <span key={index} />
          ))}
        </div>
      )}
    </div>
  );
};

CarouselPreview.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      author: PropTypes.string,
    })
  ),
  fullWidth: PropTypes.bool,
};

CarouselPreview.defaultProps = {
  images: [],
  fullWidth: false,
};

export default CarouselPreview;
